import { useEffect, useRef } from "react";
import './scss/_behandlinger.css';

export default function Behandlinger() {
    const items = [
        { title: "Fotterapi", img: "./behandling0_640.jpg", descrb: "Har du plager i føttene? Vi tilbyr profesjonell fotterapi som lindrer smerte og gir deg bedre komfort i hverdagen." },
        { title: "Behandling av inngrodde negler", img: "./behandling1_640.jpg", descrb: "Sliter du med smertefulle inngrodde negler? Vi hjelper deg trygt og skånsomt – slik at du kan gå uten ubehag igjen." },
        { title: "Torner under foter", img: "./behandling2_640.jpg", descrb: "Plages du av torner som gjør hvert steg vondt? Vi fjerner dem effektivt og hjelper deg tilbake til en smertefri hverdag." },
        { title: "Fot massasje", img: "./behandling3_640.jpg", descrb: "Trenger føttene dine avlastning og ro? En avslappende fotmassasje gir økt velvære og ny energi til hele kroppen." },
        { title: "Kinesiologitaping", img: "./behandling5_640.jpg", descrb: "Har du smerter eller belastningsplager? Kinesiologitaping gir støtte, lindrer smerte og hjelper kroppen å bevege seg bedre." },
        { title: "Vortebehandling", img: "./behandling6_640.jpg", descrb: "Vorter som ikke forsvinner? Vi tilbyr målrettet og skånsom behandling for et varig og trygt resultat."  },
        { title: "Neglesopp", img: "./behandling7_640.jpg", descrb: "Misfargede eller fortykkede negler? Vi hjelper deg med profesjonell behandling for sunnere og penere negler."  },
        { title: "Akuttime negleskader", img: "./behandling8_640.jpg", descrb: "Akutt skade på negl eller tå? Ta kontakt – vi gir rask og trygg hjelp når du trenger det mest."  },
    ];

    const sectionRef = useRef<HTMLElement | null>(null);

    useEffect(() => {
        const el = sectionRef.current;
        if (!el) return;

        const io = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    el.classList.add('item-is-visible');
                    io.unobserve(el); // один раз
                }
            },
            { threshold: 0.1 }
        );

        io.observe(el);

        return () => io.disconnect();
    }, []);


    return (
        <section id="behandlinger" className="py-16 text-center" ref={sectionRef}>
            <div className="cs-container">
                <div>
                <h2 className="section-title">Behandlinger for sunne og velstelte føtter</h2>
                <p className="section-subtitle">
                    Hos oss får du profesjonell fotterapi med fokus på både velvære, forebygging og behandling av fotproblemer. Under finner du en oversikt over våre mest populære behandlinger – alle utført av autorisert fotterapeut.
                </p>
                </div>
            <ul className="cs-card-group">
                {items.map((item, idx) => (
                    <li key={idx} className="cs-item">
                            <div className="cs-link" >
                                    <h3 className="cs-h3">{item.title}</h3>
                                    <p className="cs-item-text">{item.descrb} </p>
                            </div>
                        <picture className="cs-background">
                            <source media="(max-width: 600px)"
                                    srcSet={item.img}/>
                                <source media="(min-width: 601px)"
                                        srcSet={item.img}/>
                                    <img loading="lazy" decoding="async"
                                         src={item.img}
                                         alt={item.title} width="413" height="266"/>
                        </picture>
                    </li>
                ))}
            </ul>
           </div>
        </section>
    );
}